import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const CTA_BG =
  "https://images.pexels.com/photos/6771585/pexels-photo-6771585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

function getRefFromCookie() {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(/(?:^|; )vg_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}

function withRef(path) {
  const ref = getRefFromCookie();
  return ref ? `${path}${path.includes("?") ? "&" : "?"}ref=${encodeURIComponent(ref)}` : path;
}

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-[#B40101] py-24 md:py-32"
    >
      {/* Background image, low opacity */}
      <img
        src={CTA_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-[0.15] mix-blend-luminosity"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#B40101]/20 via-transparent to-[#8E0101]/40" />

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-8 text-center">
        <Reveal>
          <h2
            data-testid="final-cta-title"
            className="font-display font-extrabold text-white text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] max-w-3xl mx-auto"
          >
            Prima di scegliere, metti a fuoco ciò che conta.
          </h2>
        </Reveal>

        <Reveal delay={120}>
          <p
            data-testid="final-cta-text"
            className="mt-6 text-white/90 text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed"
          >
            Comincia dal progetto che hai in mente. La prima analisi completa arriverà nella tua email.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
            <a
              data-testid="final-cta-button"
              href={withRef("/orizzonti")}
              className="inline-flex items-center gap-3 bg-white hover:bg-[#F5F5F5] text-[#B40101] font-bold text-base md:text-lg px-7 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 shadow-[0_12px_30px_rgba(0,0,0,0.18)] hover:shadow-[0_18px_40px_rgba(0,0,0,0.25)]"
            >
              Inizia da OrizzontiPro <ArrowRight className="w-5 h-5" />
            </a>
            <a
              data-testid="final-cta-secondary"
              href={"/app"}
              className="inline-flex items-center gap-3 bg-transparent hover:bg-white/10 text-white font-semibold text-base md:text-lg px-7 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 border border-white/50"
            >
              Scegli un altro punto di partenza
            </a>
          </div>

          <p
            data-testid="final-cta-subtext"
            className="mt-5 text-white/80 text-sm max-w-2xl mx-auto"
          >
            Gratis. Nessuna registrazione. Nessuna telefonata parte senza la tua richiesta.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
